// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3KsZP","label":"Completed_label__1KYlc"};